import { render, staticRenderFns } from "./solution.vue?vue&type=template&id=732ca6a4&"
import script from "./solution.vue?vue&type=script&lang=ts&"
export * from "./solution.vue?vue&type=script&lang=ts&"
import style0 from "./solution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports